import { type CaseRepository, type WorkspaceRepository } from "@telespot/domain";
import { type CommandHandler } from "@telespot/core";
import { MoveCases } from "./move-cases.command";

/**
 * @group Workspaces
 * @category Handlers
 */
export type IMoveCasesHandler = CommandHandler<MoveCases>;

/**
 * @group Workspaces
 * @category Handlers
 */
export class MoveCasesHandler implements IMoveCasesHandler {

  constructor(
    private readonly workspaces: WorkspaceRepository,
    private readonly cases: CaseRepository,
  ) { }

  public async execute(command: MoveCases): Promise<void> {
    const { workspaceId, caseId } = command.details;

    const subjectCase = await this.cases.getById(caseId);
    const destWS = await this.workspaces.getById(workspaceId);

    subjectCase.moveToWorkspace(destWS);

    await this.cases.save(subjectCase);
  }
}
